import axios from 'axios';

const API_URL = (process.env.REACT_APP_BACKEND_URL || '') + '/api';

export const api = axios.create({ baseURL: API_URL });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('bce_token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err.response?.status === 401) {
      localStorage.removeItem('bce_token');
      window.location.href = '/';
    }
    return Promise.reject(err);
  }
);

export const authAPI = {
  getDiscordAuthUrl: () => api.get('/auth/discord'),
  handleCallback:    (code) => api.post('/auth/callback', { code }),
  getUserProfile:    () => api.get('/user/profile'),
};

export const applyAPI = {
  check:  () => api.get('/apply/check'),
  submit: (data) => api.post('/apply', data),
};

export const ordersAPI = {
  submit:    (data) => api.post('/orders', data),
  listMgmt:  () => api.get('/management/orders'),
  setStatus: (id, status) => api.patch(`/management/orders/${id}/status`, { status }),
};

export const myOrdersAPI = {
  list: ()           => api.get('/orders/my'),
  edit: (id, data)   => api.patch(`/orders/${id}`, data),
};

export const applicationsAPI = {
  list:      () => api.get('/management/applications'),
  setStatus: (id, status, notes) => api.patch(`/management/applications/${id}/status`, { status, notes }),
};

export const inventoryAPI = {
  listProducts:  () => api.get('/inventory/products'),
  createProduct: (data) => api.post('/inventory/products', data),
  updateProduct: (id, data) => api.patch(`/inventory/products/${id}`, data),
  deleteProduct: (id) => api.delete(`/inventory/products/${id}`),
  adjust:        (id, delta, reason, cashflow) =>
    api.post(`/inventory/products/${id}/adjust`, { delta, reason, cashflow }),
  getLogs:       () => api.get('/inventory/logs'),
  getCashflow:   () => api.get('/inventory/cashflow'),
};

// Public — no auth
export const productsAPI = {
  list: () => axios.get(`${API_URL}/products`),
};

export const statsAPI = {
  get: () => axios.get(`${API_URL}/stats`),
};

export const announcementsAPI = {
  list: () => axios.get(`${API_URL}/announcements`),
  listAll: () => api.get('/management/announcements'),
  create:  (data) => api.post('/management/announcements', data),
  update:  (id, data) => api.patch(`/management/announcements/${id}`, data),
  delete:  (id) => api.delete(`/management/announcements/${id}`),
};

export const settingsAPI = {
  getDiscord:    () => api.get('/management/settings/discord'),
  updateDiscord: (data) => api.patch('/management/settings/discord', data),
};

export const homeProductsAPI = {
  list:    () => axios.get(`${API_URL}/home-products`),
  listAll: () => api.get('/management/home-products'),
  create:  (data) => api.post('/management/home-products', data),
  update:  (id, data) => api.patch(`/management/home-products/${id}`, data),
  delete:  (id) => api.delete(`/management/home-products/${id}`),
};
